import type { SVGProps } from "react";

export const Trello = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="800px"
    preserveAspectRatio="xMidYMid"
    version="1.1"
    viewBox="0 0 256 256"
    width="800px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Trello</title>
    <defs>
      <linearGradient id="linearGradient-1" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#0091E6" />
        <stop offset="100%" stopColor="#0079BF" />
      </linearGradient>
    </defs>
    <g>
      <g>
        <rect
          fill="url(#linearGradient-1)"
          height="256"
          rx="25"
          width="256"
          x="0"
          y="0"
        />
        <rect
          fill="#FFFFFF"
          height="112"
          rx="12"
          width="78.08"
          x="144.64"
          y="33.28"
        />
        <rect
          fill="#FFFFFF"
          height="176"
          rx="12"
          width="78.08"
          x="33.28"
          y="33.28"
        />
      </g>
    </g>
  </svg>
);

export default Trello;
